import React from 'react';
import styles from './EventScore.module.css';
import { convertToBengaliNumber } from '../../BannerPart3/helper';

const EventScore = ({ events, playerLeaderboardData, playerNewYearData }) => {
  const getPlayerDataForEvent = (eventId) => {
    return playerLeaderboardData?.find(data => data.event_id === eventId) || {
      User_Rank: '-',
      score: 0,
      round_number: 0
    };
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>ইভেন্ট স্কোর</div>
      <div className={styles.gridContainer}>
        {events.map((event) => {
          const playerData = getPlayerDataForEvent(event.id);
          return (
            <div key={event.id} className={styles.card}>
              <div className={styles.eventTitle}>{event.events}</div>
              <div className={styles.scoreContainer}>
                <div className={styles.score}>
                  {convertToBengaliNumber(playerData.score)}/{convertToBengaliNumber(event.question_set)}
                </div>
                <div className={styles.rank}>
                  Rank- {playerData.User_Rank === 0 ? '-' : playerData.User_Rank}
                </div>
              </div>
            </div>
          )
        })}
        <div key={'newYear'} className={styles.card}>
          <div className={styles.eventTitle}>টুর্নামেন্ট টোটাল স্কোর</div>
          <div className={styles.scoreContainer}>
            <div className={styles.score}>
              {convertToBengaliNumber(playerNewYearData.score)}
            </div>
            <div className={styles.rank}>
              Rank- {playerNewYearData.User_Rank === 0 ? '-' : playerNewYearData.User_Rank}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventScore;
